import React, { Suspense, lazy, useContext, useEffect, useState, useRef} from "react";
import {Layout} from 'antd';
import CropClassificationStats from "../../cc-stats/cc-stats";
import TeamList from "../../team/TeamList";
import { BaseViewContext } from "../../../views/Base";

import useWindowDimensions from "../../../utilities/window_size";
import FarmersList from "../../farmers/FarmersList";
import SeasonsList from "../../seasons/SeasonsList";
import ActionSheet from "./ActionSheet";
import CCPanel from '../../crop-intelligence/CCPanel';
import { useCC, isCCPage } from '../../../contexts/CCContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InvestigateSidebarWrapper from "../../investigate-sidebar/InvestigateSidebarWrapper";

const LazyFieldsList = lazy(() => import('../../fields/FieldsList'));

//FIXME - Repetition; check App.js
const Loading = () => {
  return <p><i>Loading...</i></p>;
}

const {Sider} = Layout;

function LeftSidebarContent () {
  const cc = useCC();
  const { pathname } = useLocation();
  // Decide which content will be loaded based on current_view
  const {current_view} = useContext(BaseViewContext);




  return (
    <div className={cc.active && cc.transport === 'v2' ? 'ci-underlying-sidebar' : undefined}
      aria-hidden={cc.active && cc.transport === 'v2' ? true : undefined}>
       { cc.active && cc.transport !== 'v2' && !isCCPage(pathname) &&
        <ActionSheet>
          <CropClassificationStats />
        </ActionSheet>
      }
    {
      ["Team", "Team Member"].includes(current_view?.viewName) &&
      <TeamList />
    }
    {
      ["Farmers", "Farmer"].includes(current_view?.viewName) &&
      <FarmersList />
    }
    {
      ["Seasons", "Season"].includes(current_view?.viewName) &&
      <SeasonsList />
    }
    {
      isCCPage(pathname) && cc.transport !== 'v2' &&
      <CropClassificationStats />
    }
    {
      current_view?.viewName === "Investigate" &&
      <InvestigateSidebarWrapper 
        onHistoryLoaded={window.investigateOnHistoryLoaded} 
        historyData={window.investigateHistoryData}
      />
    }
    {
      ["Crop Growth", "Field Info", "Weather", "Home", "Fields Control Provisions", "Fields", "Tasks"].includes(current_view?.viewName) &&
        <Suspense fallback={<Loading />}>
          <LazyFieldsList />
        </Suspense>
    }

   
    </div>
  )
}

function LeftSidebar() {
  const cc = useCC();
  const { t } = useTranslation('translation');
  const mobilePanel = useRef(null);

  const [menu_collapsed, setMenuCollapsed] = useState(false);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (cc.selectedPolygon && mobilePanel.current) mobilePanel.current.open = true;
  }, [cc.selectedPolygon, width]);

  const SCREEN_WIDTH_LIMIT = 1300;

  useEffect(() => {
    if(width < SCREEN_WIDTH_LIMIT ){
      setMenuCollapsed(false);
    } else {
      setMenuCollapsed(false);
    }
  }, [width])

  const toggleMenu = () => {
    setMenuCollapsed(!menu_collapsed);
  };
  
  if (width <= 700 && cc.active && cc.transport !== 'v2') return <div className="cc-mobile-panel"><details ref={mobilePanel}>
    <summary>{t('general.crop_intelligence')} {cc.dataset?.year}</summary>
    <CropClassificationStats />
  </details></div>;

  return (
    <>
      {width <= 700 && cc.active && cc.transport === 'v2' && <div className="ci-mobile-panel"><CCPanel /></div>}
      <Sider 
        theme="light"
        width={width <= 1680 ? 350 : "15vw"} //FIXME - This should be regulated from css maybe?
        className={`left-sidebar${cc.active && cc.transport === 'v2' ? ' ci-sidebar-active' : ''}`}
        collapsible
        collapsed={menu_collapsed}
        onCollapse={() => setMenuCollapsed(!menu_collapsed)}
        collapsedWidth={0}
        trigger={null}
        style={{
          minWidth: width <= 1680 ? 350 : "2vw", //FIXME - This should be regulated from css maybe?
          overflowY: "scroll", 
          overflowX: "hidden",
          backgroundColor: '#f7f7f8',
          borderRadius: "0px 0px 3px 3px",
          boxShadow: " 0px 0px 4px 1px rgba(0,0,0,.3)",
          zIndex: 1000,
        }}
      >
        <LeftSidebarContent />
        {width > 700 && cc.active && cc.transport === 'v2' && <CCPanel />}
      </Sider>

      
    </>
  );
}

export default LeftSidebar;
